import { render, staticRenderFns } from "./CardInstagram.vue?vue&type=template&id=4453bf5c"
import script from "./CardInstagram.vue?vue&type=script&lang=js"
export * from "./CardInstagram.vue?vue&type=script&lang=js"
import style0 from "./CardInstagram.vue?vue&type=style&index=0&id=4453bf5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports